import * as PIXI from "pixi.js";
import {config} from "../../../config";
import {PixiApplication} from "../../PixiApplication";
import {Utils} from "../../Utils";
import {IFooter} from "./IFooter";

export class Footer extends PIXI.Container implements IFooter {

    public static getInstance(): Footer {
        if (!Footer.OBJ_INSTANCE) {
            Footer.OBJ_INSTANCE = new Footer();
        }
        return Footer.OBJ_INSTANCE;
    }

    private static OBJ_INSTANCE: Footer;

    private balanceText: PIXI.Text;
    private totalBetText: PIXI.Text;
    private winAmountText: PIXI.Text;
    private currencyText: PIXI.Text;

    private readonly BALANCE_TEXT_POSITION = new PIXI.Point(-200, 0);
    private readonly TOTAL_BET_TEXT_POSITION = new PIXI.Point(0, 0);
    private readonly WIN_AMOUNT_TEXT_POSITION = new PIXI.Point(200, 0);
    private readonly CURRENCY_TEXT_POSITION = new PIXI.Point(-500, 0);

    private readonly BALANCE_TEXT_PREFIX = "Balance: ";
    private readonly TOTAL_BET_TEXT_PREFIX = "Bet: ";
    private readonly WIN_AMOUNT_TEXT_PREFIX = "Win: ";
    private readonly CURRENCY_TEXT_PREFIX = "Currency: ";

    private readonly FOOTER_TEXT_STYLE = {
        fontSize: 20,
        fontFamily: "RobotoCondensedRegular",
        fontWeight: "bolder",
        fill: "#fff",
    };

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private constructor() {
        super();

        this.createAndAddBackground();
        this.createAndAddBalanceText();
        this.createAndAddTotalBetAmountText();
        this.createAndAddWinAmountText();
        this.createAndAddCurrencyText();
    }

    public setBalanceValue(value: number): void {
        this.balanceText.text = this.BALANCE_TEXT_PREFIX + Utils.formatAmount(value);
    }

    public setTotalBetAmount(value: number): void {
        this.totalBetText.text = this.TOTAL_BET_TEXT_PREFIX + Utils.formatAmount(value);
    }

    public setLastWinAmount(value: number): void {
        this.winAmountText.text = this.WIN_AMOUNT_TEXT_PREFIX + Utils.formatAmount(value);
    }

    public setCurrency(currencyType: string): void {
        this.currencyText.text = this.CURRENCY_TEXT_PREFIX + config.displayCurrency;
    }

    private createAndAddBalanceText(): void {
        this.balanceText = new PIXI.Text(this.BALANCE_TEXT_PREFIX + Utils.formatAmount(0), this.FOOTER_TEXT_STYLE);
        this.balanceText.position = this.BALANCE_TEXT_POSITION;
        this.balanceText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.balanceText);
    }

    private createAndAddTotalBetAmountText(): void {
        this.totalBetText = new PIXI.Text(this.TOTAL_BET_TEXT_PREFIX + Utils.formatAmount(0), this.FOOTER_TEXT_STYLE);
        this.totalBetText.position = this.TOTAL_BET_TEXT_POSITION;
        this.totalBetText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.totalBetText);
    }

    private createAndAddWinAmountText(): void {
        this.winAmountText = new PIXI.Text(this.WIN_AMOUNT_TEXT_PREFIX + Utils.formatAmount(0), this.FOOTER_TEXT_STYLE);
        this.winAmountText.position = this.WIN_AMOUNT_TEXT_POSITION;
        this.winAmountText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.winAmountText);
    }

    private createAndAddCurrencyText(): void {
        this.currencyText = new PIXI.Text(this.CURRENCY_TEXT_PREFIX + config.displayCurrency, this.FOOTER_TEXT_STYLE);
        this.currencyText.position = this.CURRENCY_TEXT_POSITION;
        this.currencyText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.currencyText);
    }

    private createAndAddBackground(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000);
        graphics.drawRect(0, 0,
            PixiApplication.WIDTH, 25);
        graphics.endFill();
        const background = new PIXI.Sprite(graphics.generateCanvasTexture());
        background.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/footer/Footer.ts